import type { IStudio } from "@/src/screens/Dashboard/SubComponents/Studio/interfaces/Studio.interface";

/** Requested follow-up: these two Watch Party placeholders obscure a camera. */
export function visibleWatchPartySourceLabels(studio: Pick<IStudio, "areas" | "elements">) {
  const cameraAssigned = studio.areas.some(area => area.id === "area-game" && area.media.resource?.type === "camera");
  const elements = studio.elements ?? [];
  if (!cameraAssigned) return elements;
  return elements.filter(element => !["el-sources-watch-feed-label", "el-sources-watch-feed-res"].includes(element.id));
}
